import React from "react";
import {
  FaFilePdf,
  FaFileImage,
  FaFileWord,
  FaFileExcel,
  FaFilePowerpoint,
  FaFileAlt,
  FaFileArchive,
  FaFile,
  FaCheckCircle,
  FaClock,
  FaExclamationCircle,
  FaMinusCircle,
} from "react-icons/fa";

// ── File size helper ──────────────────────────────────────────────────────────
export function formatFileSize(bytes) {
  if (!bytes && bytes !== 0) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} GB`;
}

// ── Free icons by mime type & extension ────────────────────────────────────────
export function getFileIcon(mime, fileName) {
  const ext = (fileName || "").split(".").pop().toLowerCase();
  const m = (mime || "").toLowerCase();

  if (m.includes("pdf") || ext === "pdf")
    return <FaFilePdf className="doc-type-icon pdf" />;
  if (m.includes("image") || ["jpg", "jpeg", "png", "gif", "svg", "webp"].includes(ext))
    return <FaFileImage className="doc-type-icon image" />;
  if (m.includes("word") || ["doc", "docx"].includes(ext))
    return <FaFileWord className="doc-type-icon word" />;
  if (m.includes("excel") || m.includes("spreadsheet") || ["xls", "xlsx", "csv"].includes(ext))
    return <FaFileExcel className="doc-type-icon excel" />;
  if (m.includes("presentation") || ["ppt", "pptx"].includes(ext))
    return <FaFilePowerpoint className="doc-type-icon ppt" />;
  if (["zip", "rar", "7z", "tar", "gz"].includes(ext))
    return <FaFileArchive className="doc-type-icon archive" />;
  if (m.includes("text") || ["txt", "md"].includes(ext))
    return <FaFileAlt className="doc-type-icon text" />;
  return <FaFile className="doc-type-icon generic" />;
}

// ── Professional Expiry Badges (No Emojis, Clean SVG Icons) ───────────────────
export function getExpiryBadge(status) {
  const map = {
    active: {
      cls: "expiry-badge-active",
      label: "Active",
      icon: <FaCheckCircle className="badge-icon" />,
    },
    expiring_soon: {
      cls: "expiry-badge-warning",
      label: "Expiring Soon",
      icon: <FaClock className="badge-icon" />,
    },
    expired: {
      cls: "expiry-badge-expired",
      label: "Expired",
      icon: <FaExclamationCircle className="badge-icon" />,
    },
    no_expiry: {
      cls: "expiry-badge-no-expiry",
      label: "Standard",
      icon: <FaMinusCircle className="badge-icon" />,
    },
  };
  const item = map[status] || map["no_expiry"];
  return (
    <span className={`expiry-badge ${item.cls}`}>
      {item.icon}
      <span>{item.label}</span>
    </span>
  );
}

export const CATEGORIES = [
  "General",
  "Contract",
  "Quotation",
  "Invoice",
  "Receipt",
  "Payment Voucher",
  "License",
  "Passport",
  "Visa",
  "Insurance",
  "Certificate",
  "Report",
  "Letter",
  "Other",
];

export const DOC_TYPES = [
  { value: "company", label: "Company Document" },
  { value: "employee", label: "Employee Record" },
  { value: "customer", label: "Customer File" },
  { value: "supplier", label: "Supplier File" },
];

export const ENTITY_TYPES = [
  { value: "employee", label: "Employee" },
  { value: "customer", label: "Customer" },
  { value: "supplier", label: "Supplier" },
  { value: "sale", label: "Sales Order" },
  { value: "invoice", label: "Invoice" },
  { value: "receipt", label: "Receipt" },
  { value: "quotation", label: "Quotation" },
  { value: "payment", label: "Payment Voucher" },
  { value: "bulk_sale", label: "Bulk Sale" },
];
